const URL = 'http://localhost:4000/rest/whos';

export const findAllWhos = () =>
  fetch(URL)
  .then(response => response.json());


export default {
  findAllWhos
};
